import { useLang } from "./ContentContext";

// Textes fixes de l'interface (le contenu des rubriques vient de l'éditeur)
const DICT = {
  fr: {
    tagline: "Chambre Noire — Portfolio & CV",
    enter1: "Entrez",
    enter2: "dans ma",
    enter3: "chambre.",
    iAm: "Je suis",
    introText: "Chaque objet de cette pièce raconte une partie de mon parcours. Promenez-vous, survolez, cliquez — tout s'ouvre ici, sans jamais quitter la chambre.",
    enterRoom: "Entrer dans la chambre",
    cvNoRoom: "Voir le CV sans la chambre",
    hintRotate: "Glissez pour tourner · clic droit ou deux doigts pour vous déplacer",
    hintZoom: "Molette ou pincement pour zoomer",
    hintClick: "Cliquez sur un objet",
    words: ["Réalisation", "Image", "Montage", "Étalonnage", "Photographie", "Écriture", "Clips", "Documentaire"],
    classic: "Version classique",
    cvOnly: "Voir seulement le CV",
    cvPdf: "CV en PDF",
    contactMe: "Me contacter",
    cvPdfTitle: "Télécharger mon CV en PDF",
    discovered: "objets découverts",
    discoveredAll: "Chambre entièrement explorée, merci !",
    discoverHint: "Cliquez sur les objets de la chambre pour les découvrir",
    hotspots: "Repères",
    showHotspots: "Afficher les repères",
    overview: "Vue d'ensemble",
    hint: "Glisser · tourner — Clic droit · se déplacer — Flèches · avancer — Molette · zoomer",
    prev: "Objet précédent",
    next: "Objet suivant",
    close: "Fermer",
    prevImg: "Précédente",
    nextImg: "Suivante",
    browse: "Parcourir",
    empty: "Cette rubrique est encore vide.",
    pickFilm: "Choisissez un film : il se lance ici même, sans quitter la chambre.",
    spoken: "Langues parlées",
    countries: "Pays visités",
    genres: "Genres",
    inspirations: "Inspirations artistiques",
    excerpt: "Extrait",
    sentToast: "Message envoyé — merci !",
    sendError: "Envoi impossible, réessayez.",
    yourName: "Votre nom",
    yourEmail: "Votre e-mail",
    yourMessage: "Votre message",
    emailPh: "vous@exemple.com",
    messagePh: "Parlez-moi de votre projet…",
    sending: "Envoi…",
    send: "Envoyer le message",
    sent: "Votre message est bien arrivé dans la chambre.",
    switchTo: "Switch to English",
  },
  en: {
    tagline: "Chambre Noire — Portfolio & Resume",
    enter1: "Step",
    enter2: "into my",
    enter3: "room.",
    iAm: "I'm",
    introText: "Every object in this room tells a part of my story. Wander around, hover, click — everything opens right here, without ever leaving the room.",
    enterRoom: "Enter the room",
    cvNoRoom: "View the resume without the room",
    hintRotate: "Drag to rotate · right-click or two fingers to move",
    hintZoom: "Scroll or pinch to zoom",
    hintClick: "Click on an object",
    words: ["Directing", "Cinematography", "Editing", "Color grading", "Photography", "Writing", "Music videos", "Documentary"],
    classic: "Classic version",
    cvOnly: "Resume only",
    cvPdf: "Resume PDF",
    contactMe: "Contact me",
    cvPdfTitle: "Download my resume (PDF)",
    discovered: "objects discovered",
    discoveredAll: "Room fully explored, thank you!",
    discoverHint: "Click the objects in the room to discover them",
    hotspots: "Markers",
    showHotspots: "Show markers",
    overview: "Overview",
    hint: "Drag · rotate — Right-click · move — Arrows · walk — Scroll · zoom",
    prev: "Previous object",
    next: "Next object",
    close: "Close",
    prevImg: "Previous",
    nextImg: "Next",
    browse: "Browse",
    empty: "This section is still empty.",
    pickFilm: "Pick a film: it plays right here, without leaving the room.",
    spoken: "Spoken languages",
    countries: "Countries visited",
    genres: "Genres",
    inspirations: "Artistic inspirations",
    excerpt: "Preview",
    sentToast: "Message sent — thank you!",
    sendError: "Could not send, please try again.",
    yourName: "Your name",
    yourEmail: "Your email",
    yourMessage: "Your message",
    emailPh: "you@example.com",
    messagePh: "Tell me about your project…",
    sending: "Sending…",
    send: "Send message",
    sent: "Your message has safely arrived in the room.",
    switchTo: "Passer en français",
  },
};

export const useT = () => {
  const { lang } = useLang();
  return (key) => DICT[lang]?.[key] ?? DICT.fr[key];
};
